var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_269_4816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33301 16.6663H6.66634L15.4163 7.91627C15.6352 7.6974 15.8088 7.43756 15.9273 7.15159C16.0457 6.86563 16.1067 6.55913 16.1067 6.2496C16.1067 5.94007 16.0457 5.63357 15.9273 5.34761C15.8088 5.06164 15.6352 4.8018 15.4163 4.58293C15.1975 4.36406 14.9376 4.19045 14.6517 4.072C14.3657 3.95354 14.0592 3.89258 13.7497 3.89258C13.4401 3.89258 13.1336 3.95354 12.8477 4.072C12.5617 4.19045 12.3019 4.36406 12.083 4.58293L3.33301 13.3329V16.6663Z",
    stroke: "#FCFCFC",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 5.41699L14.5833 8.75033",
    stroke: "#FCFCFC",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_269_4816"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.ac5c98f57b69771c6bb5f4aa1c8476cc.svg";
export { ForwardRef as ReactComponent };